import { render, staticRenderFns } from "./logisticsDetail.vue?vue&type=template&id=e1bce4f0&scoped=true&"
import script from "./logisticsDetail.vue?vue&type=script&lang=js&"
export * from "./logisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDetail.vue?vue&type=style&index=0&id=e1bce4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bce4f0",
  null
  
)

export default component.exports